import type { IEmployeeLocationFilterDto } from "app/pages/sales-intelligence/domain/contacts/types/filter-values";
import { FilterPanelBaseFilter } from "app/pages/sales-intelligence/modules/advanced-search-filtering/models/BaseFilter";
import type { IFilterPanelBaseFilterDeps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filters";
import type { FilterValueDelta } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/misc";
import { calculateArrayDelta } from "app/pages/sales-intelligence/modules/advanced-search-filtering/utils/calculateValueDeltaUtils";

import type { EmployeeLocationFilterOptions } from "../../types/dto";

export default class FindEmployeeLocationFilter extends FilterPanelBaseFilter<
    IEmployeeLocationFilterDto,
    EmployeeLocationFilterOptions
> {
    constructor(deps: IFilterPanelBaseFilterDeps<IEmployeeLocationFilterDto, EmployeeLocationFilterOptions>) {
        super(deps);
    }

    isValueEmpty(value: IEmployeeLocationFilterDto | undefined): boolean {
        return !value?.regions?.length && !value?.codes?.length;
    }

    toApiValue(value: IEmployeeLocationFilterDto | undefined): IEmployeeLocationFilterDto | undefined {
        if (!value) {
            return undefined;
        }

        const cleanField = <T>(field: readonly T[] | undefined): readonly T[] | undefined =>
            field && field.length ? field : undefined;

        return {
            ...value,
            regions: cleanField(value.regions),
            codes: cleanField(value.codes),
        };
    }

    calculateValueDelta(
        previousValue: IEmployeeLocationFilterDto | undefined,
        newValue: IEmployeeLocationFilterDto | undefined,
    ): FilterValueDelta<string | number> {
        const previousLocationPull = [...(previousValue?.regions ?? []), ...(previousValue?.codes ?? [])];
        const newLocationPull = [...(newValue?.regions ?? []), ...(newValue?.codes ?? [])];

        return calculateArrayDelta(previousLocationPull, newLocationPull);
    }
}
